import { render, staticRenderFns } from "./CallToActionPDF.vue?vue&type=template&id=5c2227ec&scoped=true&"
import script from "./CallToActionPDF.vue?vue&type=script&lang=js&"
export * from "./CallToActionPDF.vue?vue&type=script&lang=js&"
import style0 from "./CallToActionPDF.vue?vue&type=style&index=0&id=5c2227ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2227ec",
  null
  
)

export default component.exports